export default __webpack_public_path__ + "static/media/nodebots.d8dbc03d.svg";